import { SeItem, SeColumn } from './StyledElements'
import greenCheck from '../assets/green_checked.png'

const BaliseItem = ({ balise, on_click, is_grey, is_selected, w_a }) => {
  let temp_bg
  let temp_cl = 'black'
  if (!is_selected && !is_grey) {
    temp_bg = 'white'
  } else if (is_selected) {
    temp_bg = '#0275d8'
    temp_cl = 'white'
  } else temp_bg = 'rgba(0,0,0,.05)'

  let i = 0
  return (
    <>
      <SeItem
        id={balise.id_balise}
        onClick={on_click}
        bg={temp_bg}
        cl={temp_cl}
      >
        <SeColumn id={balise.baliseId} w={w_a[i]} align={'left'}>
          {balise.baliseName}
        </SeColumn>
        <SeColumn
          id={balise.baliseId}
          w={w_a[++i]}
          align={'left'}
          title={balise.baliseId}
        >
          {balise.baliseId}
        </SeColumn>
        <SeColumn id={balise.baliseId} w={w_a[++i]} align={'center'}>
          {balise.datas.detail === undefined && balise.datas.length > 0 && (
            <img src={greenCheck} style={{ width: '12px' }} alt="xx" />
          )}
        </SeColumn>
        <SeColumn id={balise.baliseId} w={w_a[++i]} align={'center'}>
          {balise.baliseAlt}
        </SeColumn>
        <SeColumn id={balise.baliseId} w={w_a[++i]} align={'center'}>
          {balise.baliseDist}
        </SeColumn>
      </SeItem>
    </>
  )
}

export default BaliseItem
